<div class="appo-appointment-request-finish-error">
  <div class="text-center text-lg-left d-lg-flex">
    <div class="mr-lg-3">
      <img src="assets/images/error_found.svg" width="250">
    </div>
    <div>
      <div class="appo-appointment-request-finish-error_title mb-1">{{'SI_REQUEST_AGAIN' | translate}}</div>
      <div class="appo-appointment-request-finish-error_text" [innerHTML]="textError"></div>
      <div class="container-fluid px-0 mt-4">
        <div class="row justify-content-center justify-content-lg-start pasi-gap-v-10">
          <div class="col-12 col-sm-auto">
            <button class="si-button_main w-100" (click)="onClickRequestAgain()">{{'SI_REQUEST_AGAIN' | translate}}</button>
          </div>
          <div *siExternalReference="false" class="col-12 col-sm-auto">
            <si-go-to-route-button [href]="['/']"
                                   text="SI_EXIT"
                                   styleClass="si-button_cancel w-100"
            ></si-go-to-route-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
